export const GAME_TITLE = "Islamic Connections";
export const MAX_MISTAKES = 4;
